angular.module('bmsApp')
	.service('InstanceSvc', function (AuthService, $localStorage) {

		let currentFranchiseInstance = function () {
			return $localStorage.currentInstance;
		}

		let hasNetwork = function (networkType) {
			let retVal = false;
			let user = AuthService.getUserObject();

			// if (angular.isObject(user) && angular.isDefined(user.licenses)) {
			// 	angular.forEach(user.licenses, function (lic) {
			// 		if (lic.license_type.label === networkType) {
			// 			if (angular.isObject(lic.license_sub_type)) {
			// 				if (lic.license_sub_type.value === 'RS') {
			// 					retVal = true;
			// 				}
			// 			}
			// 			else {
			// 				retVal = true;
			// 			}
			//
			// 		}
			// 	});
			// }
			let currentInstance = currentFranchiseInstance();
			// console.log(currentInstance);
			if (angular.isDefined(currentInstance)) {
				if (currentInstance.licence_type.label === networkType) {
					retVal = true;
				}
			}
			return retVal;
		};

		let hasSubNetwork = function (primaryNetwork, subNetwork) {
			let retVal = false;
			let user = AuthService.getUserObject();
			let currentInstance = currentFranchiseInstance();
			if (angular.isDefined(currentInstance.licences)) {
				angular.forEach(currentInstance.licences, function (lic) {
					if (lic.license_type.label === primaryNetwork) {
						if (angular.isObject(lic.license_sub_type)) {
							if (lic.license_sub_type.value === subNetwork) {
								retVal = true;
							}
						}
						else {
							// retVal = true;
						}

					}
				});
			}
			return retVal;
		};

		let networkHasOnly = function (network) {
			let retVal = true;
			let currentInstance = currentFranchiseInstance();
			if (angular.isDefined(currentInstance.licences)) {
				angular.forEach(currentInstance.licences, function (lic) {
					if (lic.license_type.label !== network && !angular.isObject(lic.license_sub_type)) {
						retVal = false;
					}
					else if(lic.license_type.label !== network && angular.isObject(lic.license_sub_type)){
						if (lic.license_sub_type.label !== network) {
							retVal = false;
						}
					}
					else if (lic.license_type.label !== network ) {
						retVal = false;
					}
				});
			}
			return retVal;
		};

		let ecomEnabled = function () {
			let retVal = false;
			let user = AuthService.getUserObject();
			let currentInstance = currentFranchiseInstance();
			if (angular.isDefined(currentInstance.licences)) {
				angular.forEach(currentInstance.licences, function (lic) {
					if (lic.ecom_enabled) {
						retVal = true;
					}
				});
			}
			return retVal;
		};

		// Don't check individual sub-types, just main network
		let hasSMNetwork = function (networkType) {
			let retVal = false;
			let user = AuthService.getUserObject();
			let currentInstance = currentFranchiseInstance();
			if (angular.isDefined(currentInstance.licences)) {
				angular.forEach(currentInstance.licences, function (lic) {
					if (lic.license_type.label === networkType) {
						retVal = true;
					}
				});
			}
			return retVal;
		};

		return {
			instance: {
				currentFranchiseInstance: currentFranchiseInstance,
				isMM: function () {
					return hasNetwork('Merry Maids');
				},
				isTG: function () {
					return hasNetwork('TruGreen');
				},
				isSM: function () {
					// This is slightly confusing, but essentially this actually means, is it SM AND Res
					return hasNetwork('ServiceMaster Clean');
				},
				isSMNetwork: function () {
					return hasNetwork('ServiceMaster Clean');
					// return hasSMNetwork('ServiceMaster Clean');
				},
				isCS: function () {
					return hasNetwork('Contract Services');
				},
				isRB: function () {
					return hasNetwork('Rosemary Bookkeeping');
				},
				isFM: function () {
					return hasNetwork('Furniture Medic');
				},
				hasSubNetwork: function ($network) {
					return hasSubNetwork('ServiceMaster Clean', $network);
				},
				hasFeeMethod: function (feeMethod) {
					let retVal = false;
					let currentInstance = currentFranchiseInstance();
					if (angular.isDefined(currentInstance.licences)) {
						angular.forEach(currentInstance.licences, function (lic) {
							if (lic.license_type.fee_method.value === feeMethod || (angular.isObject(lic.license_sub_type) && lic.license_sub_type.fee_method.value === feeMethod)) {
								retVal = true;
							}
						});
					}
					return retVal;
				},
				isDumbNetwork: function () {
					return ((hasNetwork('Contract Services') || hasNetwork('Rosemary Bookkeeping') || hasNetwork('Furniture Medic') || (networkHasOnly('SM Restore') && hasNetwork('ServiceMaster Clean') ))) ;
				},
				isMMPayByPercentage: function () {
					var userInfo = AuthService.getUserObject();
					return (angular.isObject(userInfo) && angular.isObject(userInfo.app_settings) && userInfo.app_settings.mm_pay_method == 'percentage');
				},
				isMMPayByHourly: function () {
					var userInfo = AuthService.getUserObject();
					return (angular.isObject(userInfo) && angular.isObject(userInfo.app_settings) && userInfo.app_settings.mm_pay_method == 'hourly');
				},
				isMMPayByAttendance: function () {
					var userInfo = AuthService.getUserObject();
					return (angular.isObject(userInfo) && angular.isObject(userInfo.app_settings) && userInfo.app_settings.mm_pay_method == 'hourly' && userInfo.app_settings.mm_pay_hourly_method == 'attendance');
				},
				isMMPayByJobDuration: function () {
					var userInfo = AuthService.getUserObject();
					return (angular.isObject(userInfo) && angular.isObject(userInfo.app_settings) && userInfo.app_settings.mm_pay_method == 'hourly' && userInfo.app_settings.mm_pay_hourly_method == 'job');
				},
				getAll: function () {
					return AuthService.getUserObject().licenses;
				},
				getFranchiseId: function () {
					return AuthService.getUserObject().franchise.id;
				},
				getFranchiseApiKey: function () {
					return AuthService.getUserObject().franchise.api_key;
				},
				getFranchise: function () {
					return AuthService.getUserObject().franchise;
				},
				ecomEnabled: function () {
					return ecomEnabled();
				},
				isTrainingUser: function () {
					return AuthService.getUserObject().role_list === 'training';
				},

			}
		};
	});
